import React from 'react';
import { Wrapper, Flex, BottomWrapper, ChangeState } from './common'
import NamesList from './mainpage/NamesList';
import ShowDetails from './mainpage/ShowDetails'
import Favourites from './favorites/favourites';  

const MainPage = (props)=>{
    return(
          <React.Fragment>
                <Wrapper>
                  <Flex>
                     <NamesList names={props.names} setCurrentName={props.setCurrentName} addFavourites={props.addFavourites}/>
                     <ShowDetails currentName={props.currentName}  incrementCounter={props.incrementCounter} favourites={props.favourites}/>
                  </Flex>
        </Wrapper>
               <BottomWrapper>
                    <ChangeState>
                        <Flex>
                          <Favourites/>
                             <Favourites/>
                          <Favourites/>
                       </Flex>
                    </ChangeState>
        </BottomWrapper>
    </React.Fragment>
    )
};

export default MainPage;


// WEBPACK FOOTER //
// ./src/components/MainPage.js